import styled, { css } from 'styled-components';
import { getColor, StyleVars } from '../../utils/Styles';

export const InputGroupStyled = styled.div`
	margin-bottom: ${({ tight }) => tight ? '0px' : `${StyleVars.defaultSpacingUnit * 1.5}px`};

	&:last-of-type {
		margin-bottom: 0;
	}

	label {
		font-size: 18px;
		font-weight: 600;
		margin-bottom: 8px;
		display: flex;
		align-items: center;
	}
`;

// Select Styles
export const DropdownWrapperStyled = styled(InputGroupStyled)`
	position: relative;

	&:after {
		position: absolute;
		top: ${({ labeled, tight }) => !labeled ? '50%' : tight ? '70%' : '65%'};
		right: 15px;
		display: inline-block;
		content: "";
		width: 0;
		height: 0;
		margin-top: -2px;
		pointer-events: none;
		border-top: 6px solid ${getColor('dustyGray')};
		border-right: 5px solid transparent;
		border-bottom: 6px solid transparent;
		border-left: 5px solid transparent;
	}
`;

export const SelectStyled = styled.select`
	cursor: pointer;
	appearance: none;
	text-overflow: '';
	border: 1px solid ${getColor('gray3')};
	border-radius: ${StyleVars.defaultBorderRadius};
	line-height: 1.42;
	width: 100%;
	padding: ${({ tight }) => tight ? `${StyleVars.defaultSpacingUnit * 0.75}px` : `${StyleVars.defaultSpacingUnit}px`};
	outline: none;
	transition: border-color 0.3s ease-in-out;
	background: ${getColor("white")};

	&:focus,
	&:active {
		border: 1px solid ${getColor('primaryBrand')};
	}
`;

// Input Helper Components
export const HelpTextStyled = styled.div`
	color: ${getColor('limedSpruceGray')};
	font-size: 12px;
	margin: 8px 0;
`;

export const ErrorTextStyled = styled.div`
	color: ${getColor('bridesmaid')};
	font-size: 12px;
	margin-top: 4px;
`;
